function sizeCheck(){
    if(isExtraLargeCheck()){
      return 'xl';
    }
    else if(isLargeCheck()){
      return 'lg';
    }
    else if(isMediumCheck()){
      return 'md';
    }
    else if(isSmallCheck()){
      return 'sm';
    }
    else if(isExtraSmallCheck()){
      return 'xs';
    }
}
function isExtraLargeCheck(){
    return (window.matchMedia("(min-width: 1200px)").matches ? true : false);
}
  function isLargeCheck(){
    return (window.matchMedia("(min-width: 992px)").matches ? true : false);
}
  function isMediumCheck(){
    return (window.matchMedia("(min-width: 768px)").matches ? true : false);
}
  function isSmallCheck(){
    return (window.matchMedia("(min-width: 576px)").matches ? true : false);
}
  function isExtraSmallCheck(){
    return (window.matchMedia("(max-width: 576px)").matches ? true : false);
}

function setSizeStates(setSize){
    let size = sizeCheck();

    setSize(size);
    return size;
}

export function getSize(){
  return sizeCheck();
}

export function isMobile(size){
  if(size === 'xs'){
    return true;
  }
  return false;
}

export default setSizeStates;